import styled from 'styled-components';

export const FAQButtonWrapper = styled.div`
  display: block;
  position: fixed;
  top: 240px;
  left: 0;
  margin-left: 30px;
  width: 100px;
  cursor: pointer;
`;
